import { render, staticRenderFns } from "./BotaoAnaliseDesmatamento.vue?vue&type=template&id=500e46a2&lang=pug"
import script from "./BotaoAnaliseDesmatamento.vue?vue&type=script&lang=js"
export * from "./BotaoAnaliseDesmatamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports